import { baseGrtURL } from '../../httpService/API';
import { hMacAjax } from '../../httpService';
import { getBusinessSearchParams } from '@/utils/Page';
const centerUrl = `${baseGrtURL}/api/grt-user-center-service`;

export const url = {
    feedback: `${centerUrl}/open/agent/feedback` //反馈
};
//反馈
export function handleSaveFeedBack(data) {
    let searchParams = getBusinessSearchParams();
    data = {
        ...data,
        ...searchParams
    };
    return hMacAjax.post(url.feedback, data);
}
